import ClassBreaksRenderer from '@arcgis/core/renderers/ClassBreaksRenderer';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import Color from '@arcgis/core/Color';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

import LabelClass from "@arcgis/core/layers/support/LabelClass";
import PopupTemplate from '@arcgis/core/PopupTemplate';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import { fieldSampleColors } from 'src/constants';
import moment from 'moment';
import { roundOneDecimal } from 'src/store/common';

const popupTemplate = new PopupTemplate({
    title: "{id}",
    content: "<div id='custompoop' key='custompoop' class='custompoop' style='padding: 10px'>{name}</div>",

    outFields: ["{id}"],
    fieldInfos: [
        {fieldName: 'id', visible: false},
        {fieldName: 'name', visible: false},
        {fieldName: 'latestSampleDate', visible: false},
    ]
});

//legend has:
//sample value in the range
//sample value present but outside the date ragne specified
// no data for this site

const findLabelValue = (fuelSampleData: any)=>{
    if(fuelSampleData.latestSampleAverageInRange){
        return roundOneDecimal(fuelSampleData.latestSampleAverageInRange)?.toString();
    }
    else{
        return '';
    }
}

const findHiddenValue = (fuelSampleData: any)=>{
    if(fuelSampleData.latestSampleAverageInRange){
        return roundOneDecimal(fuelSampleData.latestSampleAverageInRange)?.toString();
    }
    else if(fuelSampleData.firstSampleDate && fuelSampleData.latestSampleDate && (!fuelSampleData.latestSampleDateInRange || !fuelSampleData.latestSampleAverageInRange)){
        return -100;
    }
    else{
        return -200
    }
}


/* test feature layer this is where to test to see how to add a layer*/
export const formatFSDataToLayer = (data: any[], fuelType: any, zoom: number, startDate: any, endDate: any, method: string, category:string, subCategory: string) => {
    /*below is a geojson layer for observations*/
    const filterOutInactive = data.filter((data)=>data.active ===1);
    const dataGraphics = filterOutInactive.map((item) =>
        new Graphic({
            geometry: new Point({
                latitude: item.latitude,
                longitude: item.longitude,
                spatialReference: new SpatialReference({ wkid: 4326 })
            }),
            attributes: {
                name: item.siteName,
                id: item.siteId,
                latestSampleDate: item?.latestSampleDate,
                value: findHiddenValue(item.fuelSampleMetadata),
                label: findLabelValue(item.fuelSampleMetadata),
                elevation: item.elevation,
            }

        })
    );
    const dataFeatureLayer = new FeatureLayer({
        source: dataGraphics,
        objectIdField: 'ObjectId',
        popupTemplate: popupTemplate,
        editingEnabled: true,
        id: `fieldSample&FuelType=${fuelType}&Method=${method}&Category=${category}&SubCategory=${subCategory}&Zoom=${zoom}&StartDate=${moment(startDate).utc().format('YYYY-MM-DD')}&EndDate=${moment(endDate).utc().format('YYYY-MM-DD')}`,
        fields: [
            {
                name: "ObjectId",
                type: 'oid'
            },
            {
                name: "value",
                type: "double"
            },
            {
                name: "name",
                type: "string"
            },
            {
                name: "id",
                type: "integer"
            },
            {
                name: "latestSampleDate",
                type: "string"
            },
            {
                name: "label",
                type: "string"
            },
            {
                name: "elevation",
                type: "integer"
            },
        ],
        geometryType: "point",
        outFields: ["ObjectID", "name", "id", "latestSampleDate"]

    })
    const dataRenderer = new ClassBreaksRenderer({
        field: "value",
        classBreakInfos: fieldSampleColors.map((color: any) => ({
            minValue: color.minValue,
            maxValue: color.maxValue,
            symbol: new SimpleMarkerSymbol({
                color: new Color(color.rgb),
                size: "30px",
                outline: {
                    color: color.minValue !== -200 ? '#006546': new Color(color.rgb),
                    width: 2
                }
            }),
            label: "id"
        }))
    });


    const labelingInfo = new LabelClass({
        labelExpressionInfo: { expression: "$feature.label" },
        symbol: {
            type: "text",
            color: 'black',
            font: {
                size: "10px",
            }
        },
        deconflictionStrategy: "none",
        labelPlacement: "center-center",
    });

    dataFeatureLayer.renderer = dataRenderer;
    dataFeatureLayer.labelsVisible = true;
    dataFeatureLayer.labelingInfo = [labelingInfo];

    return { dataLayer: dataFeatureLayer};
};